// extracted by mini-css-extract-plugin
export default {"indicator":"useSpellCorrector-module__indicator--lhMKc"};